

export const styleCarga = {
  background: 'white',
  borderRadius: '10px',
  p: 20,
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'center' // ojo: era alignItem -> alignItems
};

export const buttonGuardar = {
  fontFamily: "Poppins",
  background: "#079e7bff",
  textTransform: "capitalize",
  color: '#fff',
  transition: "all 0.3s ease",
  "&:hover": {
    background: "#05644eff",
    transform: "scale(1.05)",
  },
};

export const buttonCancelar = {
  fontFamily: "Poppins",
  background: "#d3624eff",
  textTransform: "capitalize",
  color: '#fff',
  transition: "all 0.3s ease",
  "&:hover": {
    background: "#640505ff",
    transform: "scale(1.05)",
  },
};

export const buttonCerrar = {
  fontFamily: "Poppins",
  background: "#449977ff",
  textTransform: "capitalize",
  color: '#fff',
  transition: "all 0.3s ease",
  "&:hover": {
    background: "#0c7d6eff",
    transform: "scale(1.05)",
  },
};

export const inputFecha = {
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  borderRadius: 2,
  width: 180,
  position: 'relative',
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    transition: "all 0.3s ease",
    "& fieldset": {
      borderColor: "#ccc",
    },
    "&:hover fieldset": {
      borderColor: "#43c593",
      boxShadow: "0 0 6px #43c59366",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#43c593",
      boxShadow: "0 0 8px #43c59399",
    },
  },
  "& .MuiInputBase-root": {
    color: "#585857",
    fontFamily: "Poppins",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2a8d74",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2a8d74",
  },
  "& .MuiInputAdornment-root svg": {
    color: "#2a8d74",
  },
  "& input::-webkit-calendar-picker-indicator": {
    opacity: 0,
    position: 'absolute',
    right: 0,
    cursor: "pointer",
    zIndex: 1,
    width: '60px',
    height: '100%'
  },
};

export const InputDescripcion = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px", // 👈 borde redondeado
    transition: "all 0.3s ease",
    "& fieldset": {
      borderColor: "#ccc", // color normal
    },
    "&:hover fieldset": {
      borderColor: "#43c593", // 👈 color en hover
      boxShadow: "0 0 6px #43c59366", // 👈 efecto glow
    },
    "&.Mui-focused fieldset": {
      borderColor: "#43c593", // color al hacer focus
      boxShadow: "0 0 8px #43c59399",
    },
  }
}

export const ButtonStyle = {
  fontFamily: "Poppins",
  background: "#808386",
  color:'#fff',
  textTransform: "capitalize",
  transition: "all 0.3s ease", // suaviza el hover
  "&:hover": {
    background: "#079e7bff", // color al pasar el mouse
    transform: "scale(1.05)", // opcional, un leve zoom
  },
};
export const buttonAtras = {
  fontFamily: "Poppins",
  background: "#df9f41ff",
  color: '#fff',
  textTransform: "capitalize",
  transition: "all 0.3s ease", // suaviza el hover
  "&:hover": {
    background: "#b96a1fff", // color al pasar el mouse
    transform: "scale(1.05)", // opcional, un leve zoom
  },
};



export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  maxHeight: '80vh',
  p: 4,
  borderRadius: 3,
  boxShadow: 6,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  gap: 2,
}

export const Titulo = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: '1.3rem',
  color: '#585857',
  textAlign: 'center',
};

export const SubTitulo = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: '1rem',
  color: '#585857',
  textAlign: 'center',
};

export const SubTitulodos = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: '1.2rem',
  color: '#585857',
};

export const Input = {
  fontFamily:'Poppins',
  backgroundColor: "rgba(255, 255, 255, 0.1)", // transparente con ligera visibilidad
  "& .MuiOutlinedInput-root": {
    fontFamily:'Poppins',
    borderRadius: "50px", // 👈 borde redondeado
    transition: "all 0.3s ease",
    "& fieldset": {
      borderColor: "#ccc", // color normal
    },
    "&:hover fieldset": {
      borderColor: "#43c593", // 👈 color en hover
      boxShadow: "0 0 6px #43c59366", // 👈 efecto glow
    },
    "&.Mui-focused fieldset": {
      borderColor: "#43c593", // color al hacer focus
      boxShadow: "0 0 8px #43c59399",
    },
  }
}


export const Texto ={
  fontFamily:'Poppins',
  fontWeight:600,
  color:'#585857'
}

export const BoxBoton ={
  width:'100%',
  display:'flex',
  justifyContent:'flex-end',
  mt:'-30px'
}

export const Icono = {
  fontSize:'1.8rem', 
  margin:'10px',
  color:'#585857'
}

export const BoxPerfil ={
  display:'flex',
  alignItems:'center',
  flexDirection:'row',
  mb:3
}

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "350px",
  bgcolor: "#fff",
  boxShadow: 24,
  p: 2,
  borderRadius: "10px",
};

export const TituloPrincipal = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: '1.3rem',
  color: '#585857',
  
};


export const TituloColor = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: '1.2rem',
  color: '#05644eff',
  textAlign: 'center',
};


export const InputBuscador = {
  fontFamily:'Poppins',
  fontSize:'0.8rem',
  backgroundColor: "rgba(255, 255, 255, 0.1)", // transparente con ligera visibilidad
  "& .MuiOutlinedInput-root": {
    fontSize:'0.8rem',
    fontFamily:'Poppins',
    borderRadius: "50px", // 👈 borde redondeado
    transition: "all 0.3s ease",
    "& fieldset": {
      borderColor: "#ccc", // color normal
    },
    "&:hover fieldset": {
      borderColor: "#43c593", // 👈 color en hover
      boxShadow: "0 0 6px #43c59366", // 👈 efecto glow
    },
    "&.Mui-focused fieldset": {
      borderColor: "#43c593", // color al hacer focus
      boxShadow: "0 0 8px #43c59399",
    },
  }
}

export const inputFechaGrande = {
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  borderRadius: 2,
  width: '100%',
  position: 'relative',
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    transition: "all 0.3s ease",
    "& fieldset": {
      borderColor: "#ccc",
    },
    "&:hover fieldset": {
      borderColor: "#43c593",
      boxShadow: "0 0 6px #43c59366",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#43c593",
      boxShadow: "0 0 8px #43c59399",
    },
  },
  "& .MuiInputBase-root": {
    color: "#585857",
    fontFamily: "Poppins",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2a8d74",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2a8d74",
  },
  "& .MuiInputAdornment-root svg": {
    color: "#2a8d74",
  },
  "& input::-webkit-calendar-picker-indicator": {
    opacity: 0,
    position: 'absolute',
    right: 0,
    cursor: "pointer",
    zIndex: 1,
    width: '60px',
    height: '100%'
  },
};

export const TextoTablaIngresoEgreso = {
 fontFamily:'Poppins', 
 fontWeight:'500',
 fontSize:'1rem',
 color:'#585857'
}